// import axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui'
import store from '@/store'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getRefreshCode, apiPostSToken } from '@/api/user'
import router, { resetRouter } from '@/router';
import SocketInstance from '@/im-server/socket-instance'
import Vue from 'vue';

const codesMsg = {
  '20000': ['Wechat Error'],
  '20001': ['账号或密码错误'],
  '20002': ['密码已过期，请修改密码'],
  '20003': ['账号已锁定，请联系管理员'],
  '40000': ['参数错误'],
  '40001': ['参数不能为空'],
  '40100': ['token过期'],
  '40101': ['Token无效'],
  '40102': ['Token缺失'],
  '40105': ['RefreshToken失效'],
  '40106': ['生成TableAu,Ticket权限错误：username错误或者服务器IP未授权'],
  '40108': ['验证码错误'],
  '40300': ['账号无访问资源权限'],
  '40401': ['文件不存在'],
  '50000': ['系统内部错误'],
  '50001': ['JwtTokenFilter处理异常'],
  '50002': ['文件上传异常'],
  '50003': ['文件格式错误'],
  '50004': ['数据库操作错误'],
  '50005': ['服务访问超时'],
  '100000': ['内部系统错误'],
  '200000': ['OCS权限错误'],
  '300000': ['OCS参数错误'],
  '400000': ['OCS权限错误'],
  '400001': ['菜单类错误'],
  '200001': ['密码不得小于8位字符,含字母、数字、特殊字符'],
  '200002': ['密码与近期使用的密码相同，请更换密码'],
  '600001': ['文件大小超出最大限制!'],
  '100001': ['id-generator服务异常'],
  '100002 ': ['网络异常请稍后重试'],
  '100003': ['未知错误'],
  'default': ['服务器开小差了,请稍后重试'],
}

let isRefreshing = false // 标记是否正在刷新 token
let requests = [] // 存储待重发请求的数组

let host = window.location.host;
let api_url = "", Sys = {}, ua = navigator.userAgent.toLowerCase(), s, l = window.location;
    // eslint-disable-next-line no-cond-assign
    (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1] :
    // eslint-disable-next-line no-cond-assign
    (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] : 0;
    if(Sys.ie) {
        api_url = l.protocol + '//' + l.host;
    }else{
        api_url = l.origin;
    }
const service = axios.create({
     // baseURL: process.env.NODE_ENV == 'development' ? process.env.VUE_APP_BASE_API : '',
	//  baseURL: process.env.NODE_ENV == 'development' ? (api_url + '/api/') : api_url,
	baseURL: process.env.NODE_ENV == 'development' ? (api_url + '/api/') : api_url,
	// baseURL: '',
    timeout: 1000 * 30 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
	if (store.getters.token) {
		if(config.contentType === 'formData') {
			config.data = (typeof config.data === "object") ? qs.stringify(config.data) : config.data;
			config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
		}

		if(config.baseUrlType === 'virtualHost') {
			config.baseURL = store.getters.virtual_host;
			config.url = '';
		}

		if(config.baseUrlType === 'larkSwitch' && process.env.NODE_ENV !== 'development') {
			if(store.getters.lark_switch_url) {
				config.baseURL = store.getters.lark_switch_url;
			} else {
				Message.error({message:'本品牌尚未配置Lark switch地址', customClass:'customer-zIndex'})
				throw new axios.Cancel('本品牌尚未配置Lark switch地址');
			}
		}
		config.headers.Authorization = getToken('access_token');
	}
	config.headers['Lang'] = 'zh_CN';
	return config;
}, error => {
	return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
    response => {
        if (response.data.errcode && Number(response.data.errcode) !== 0) {
				Vue.prototype.$$log({
					category: "ApiError", // 页面错误
					message: response?.data ? JSON.stringify(response?.data) : 'null', // 错误详情
				});
			 // let msg = codesMsg[response.data.errcode] || codesMsg['default'];
			 if(!['/ocs-weblog/log/add'].includes(response?.config?.url)) {
				Message.error({message: response.data.errmsg, customClass:'customer-zIndex'})
			 }
				if(response.data.errcode == 20003){ // 登入密码过期，将返回reponse.data;
					return response.data;
				}
       			return response.data
		 }
		return response.data;
    },
    error => {
		if(error?.response?.data?.status) {
			Vue.prototype.$$log({
				category: "ApiError", // 页面错误
				message: JSON.stringify(error.response), // 错误详情
			});
		}
        const { config } = error;
		if (error && error.response) {
			if (error.response.data.errcode == '40100') {
				let refresh_token = getToken('refresh_token');
				if(refresh_token) {
					if(!isRefreshing){
						isRefreshing = true
						return getRefreshCode({refreshtoken: refresh_token}).then(res=> {
								const { access_token } = res.data
								config.headers.Authorization = access_token
								setToken("access_token", res.data.access_token)
								setToken("refresh_token", res.data.refresh_token)
								localStorage.setItem('access_token', res.data.access_token);
								localStorage.setItem('refresh_token', res.data.refresh_token);

								// apiPostSToken().then(resp => {
								// 	setToken("s_access_token", resp.data);
								// });
								// while (requests.length > 0) {
								// 	requests[0](access_token);
								// 	requests.shift();
								// }
								requests.forEach((cb) => cb(access_token))
								requests = [] // 重新请求完清空
								return service(config)
							}).catch(err => {
								// Message.error("抱歉，您的登录状态已失效，请重新登录！")
								resetLogout();
								// router.push(`/login?redirect=${router?.currentRoute?.fullPath}`);
								return Promise.reject(err)
							}).finally(() => {
								isRefreshing = false
							})
					}else {
						return new Promise(resolve => {
							// setTimeout(()=>{
							// 	resolve(service(config));
							// }, 500)
							// 用函数形式将 resolve 存入，等待刷新后再执行
							requests.push(token => {
								config.headers.Authorization = token
								resolve(service(config))
							}) 
						})
					}
				}else {
					// Message.error("抱歉，您的登录状态已失效，请重新登录！")
					Message.error({message: "登录超时!", customClass:'customer-zIndex'})
					logout();
					// router.push(`/login?redirect=${router?.currentRoute?.fullPath}`);
				}
			}
			switch (error.response.data.errcode) {
				case 40101:
				case '40101':
				case 40102:
				case '40102':
				case 40103:
				case '40103':
				case 40105:
				case '40105':
					// Message.error('抱歉，您的登录状态已失效，请重新登录！')
					Message.error({message: error.response.data.errmsg, customClass:'customer-zIndex'})
					resetLogout();
					// router.push(`/login?redirect=${router?.currentRoute?.fullPath}`);
					break;
				default:
					if(!['/ocs-weblog/log/add'].includes(error.response.config.url)) {
						Message.error({message: error.response.data['errmsg'] ? error.response.data['errmsg'] : '服务暂时不可用，请稍后再试',customClass:'customer-zIndex'})
					}
			}
			
		}
        function logout() {
			store.dispatch('user/logout');

		}
		function resetLogout(){
			SocketInstance.close();
			Vue.prototype.$iMLocalforage.clear();
			store.commit('user/SET_TOKEN', '');
			store.commit('user/SET_ROLES', []);
			store.commit('user/SET_USER_INFO', {});
			store.commit('user/SET_SERVICESTATUS',{})
			removeToken();
			resetRouter();
			localStorage.clear()
			store.dispatch('tagsView/delAllViews', null, { root: true });
			router.push(`/login`);
		}
		return Promise.reject(error)
		
	}
)

export default service
